module.exports = __webpack_public_path__ + "static/media/operators.76a6c10d.svg";